/* eslint-disable */
/**
 * 官网百度统计
 */
export default () => {
  var _hmt: any = _hmt || [];
  (function () {
    var hm = document.createElement('script');
    hm.src = 'https://hm.baidu.com/hm.js?948a3e71e024991ef78897ecf6377e4e';
    var s = document.getElementsByTagName('script')[0];
    s.parentNode?.insertBefore(hm, s);
  })();
};
